module.exports = __webpack_public_path__ + "static/media/Aerial Bunched Cables.f2f768c9.png";